import { render } from "./PageContainer.vue?vue&type=template&id=5b133416&scoped=true&lang=pug"
import script from "./PageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContainer.vue?vue&type=script&setup=true&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=5b133416&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b133416"]])

export default __exports__